<script>
    import Carousel from "svelte-carousel";
    import { fly } from 'svelte/transition'

    const images = [
        "./photos/background-main.png",
        "./photos/1.jpeg",
        "./photos/2.jpeg",
        "./photos/3.jpeg",
        "./photos/4.jpeg",
        "./photos/5.jpeg",
        "./photos/6.jpeg",
        "./photos/7.jpeg",
        "./photos/8.jpeg",
        "./photos/10.jpeg",
    ];

    async function preloadImages(images) {
        await Promise.all(images.map(src => preload(src)));
    }

    function preload(src) {
        return new Promise(function(resolve) {
            let img = new Image();
            img.onload = resolve;
            img.src = src;
        });
    }

    let expandedImage = null;

    function expandImage(imageUrl) {
        expandedImage = imageUrl;
    }

    function collapseImage() {
        expandedImage = null;
    }

    preloadImages(images);
</script>

<style>
    .header-span{
        font-size: 18px;
        text-align: center;
        margin-bottom: 30px;
    }
    .image-gallery {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(25%, 1fr));
    }

    .image-container {
        padding: 10px;
        position: relative;
    }

    .image-container img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        cursor: pointer;
        border-radius: 5px;
        transition: transform 0.3s ease;
    }

    .image-container:hover img {
        transform: scale(1.05);
    }

    .expanded-image-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.9);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
    }

    .expanded-image {
        max-width: 90%;
        max-height: 90%;
        border-radius: 5px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    }

    .close-btn {
        position: absolute;
        top: 10px;
        right: 10px;
        color: #fff;
        font-size: 20px;
        cursor: pointer;
    }
    .mobile-layout {
        display: none;
    }

    .img-span{
        font-size:24px;
        font-weight: bold;
    }

    .desktop-layout{
        margin: 0 5% 5% 5%;
    }
    @media screen and (max-width: 768px) {
        .desktop-layout {
            display: none;
        }
        .mobile-layout {
            display: block;
        }
        .header-span{
            margin-bottom: 0;
        }
        .img-span{
            font-size:22px;
        }
    }
</style>

<div class="desktop-layout">
    <div class="main-div">
        <div class="header-span">
            <span class="img-span">Specializzazione:</span><br/>
            <span>Ciglia & Sopracciglia</span>
        </div>
        <div>
            <Carousel
                let:loaded
                particlesToShow={5}
                particlesToScroll={1}
                autoplay
                autoplayDuration={2000}
                pauseOnFocus
                >
                {#each images as image, imageIndex (image)}
                    <div class="image-container" on:click={() => expandImage(image)}>
                        {#if loaded.includes(imageIndex)}
                            <img src={image} alt="Image" in:fly/>
                        {/if}
                    </div>
                {/each}
            </Carousel>
        </div>
    </div>
    {#if expandedImage}
        <div class="expanded-image-container" on:click={collapseImage}>
            <span class="close-btn" on:click={collapseImage}>&times;</span>
            <img class="expanded-image" src={expandedImage} alt="Expanded Image"/>
        </div>
    {/if}
</div>

<div class="mobile-layout">
    <div class="main-div">
        <div class="header-span">
            <span style="font-size:22px;font-weight: bold;">Specializzazione:</span><br/>
            <span>Ciglia & Sopracciglia</span>
        </div>
        <div class="image-gallery">
            {#each images as image}
                <div class="image-container" on:click={() => expandImage(image)}>
                    <img src={image} alt="Image"/>
                </div>
            {/each}
        </div>
    </div>
    {#if expandedImage}
        <div class="expanded-image-container" on:click={collapseImage}>
            <span class="close-btn" on:click={collapseImage}>&times;</span>
            <img class="expanded-image" src={expandedImage} alt="Expanded Image"/>
        </div>
    {/if}
</div>